require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/fn/object/assign.js
// module id = 595
// module chunks = 168707334958949